import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SelfEvaluationService } from '../../self-evaluation.service';
import { AppService } from '../../../app.service';

@Component({
    selector: 'self-evaluation-progressbar-component',
    templateUrl: './self-evaluation-progressbar.component.html',
})
export class SelfEvaluationProgressbarComponent implements OnInit{
    @Input() activePage: number;
    @Input() percentage: number;
    @Input() total: number;
    @Input() isAdditional: boolean;
    @Input() haveAnamnestic: boolean = false;
    @Input() step: number;
    STEPS_PERCENTAGES = {
        se: {
            previous: 0,
            1 : 25,
            2 : 35,
            additional : 15,
            3 : 0,
            4 : 15,
            5 : 10,
            anamnestic : 25
            // 1 : 0 - 25 - 60 - (75) - 90 - 100
        },
        repeatedSE: {
            previous: 10,
            1 : 15,
            2 : 35,
            additional : 15,
            3 : 0,
            4 : 15,
            5 : 10,
            anamnestic : 25
            // 1 : 0 - (10) - 25 - 60 - (75) - 90 - 100
        }
    };

    constructor(
        public selfEvaluationService: SelfEvaluationService,
        public appService: AppService,
    ) {
    }

    ngOnInit(){
        this.generateProgressBar();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['activePage'] && this.activePage) {
            return this.generateProgressBar();
        }
    }

    generateProgressBar(){
        this.percentage = 0;
        if(this.activePage && this.total){
            let PERCENTAGE = this.STEPS_PERCENTAGES[this.appService.SEType];
            // Step 0 -> 1
            if( this.step == 1){
                if(this.appService.SEType === this.selfEvaluationService.TYPES.REPEATED){
                    if(this.appService.SEData.hasOwnProperty('is_finish_first_repeated_step') && this.appService.SEData.is_finish_first_repeated_step == 0){
                        PERCENTAGE = this.STEPS_PERCENTAGES[this.appService.SEType]['previous'];
                        this.percentage = Math.floor(this.activePage / this.total * PERCENTAGE);
                        return this.percentage;
                    }
                    this.percentage = Math.floor(this.activePage / this.total * PERCENTAGE[this.step]) + this.STEPS_PERCENTAGES[this.appService.SEType]['previous'];
                    return this.percentage;
                }
                this.percentage = Math.floor(this.activePage / this.total * PERCENTAGE[this.step]);
                return this.percentage;
            }

            // Step 2
            if( this.step == 2){
                let percentageForStep2 = PERCENTAGE[2];
                if(PERCENTAGE['anamnestic']){
                    percentageForStep2 = this.haveAnamnestic ? percentageForStep2 : (percentageForStep2 + PERCENTAGE['anamnestic']);
                }
                if(!this.isAdditional){
                    this.percentage = Math.floor(this.activePage / this.total * percentageForStep2);
                } else{
                    this.percentage = Math.floor(this.activePage / this.total * PERCENTAGE['additional']) + percentageForStep2;
                }
                this.percentage += PERCENTAGE['previous'] + PERCENTAGE[1];
                return this.percentage;
            }

            // Step >= 3
            for (const [key, value] of Object.entries(this.STEPS_PERCENTAGES[this.appService.SEType])) {
                if(Number(key) === this.step){
                    break;
                }
                this.percentage += Number(value);
            }
            this.percentage += this.STEPS_PERCENTAGES[this.appService.SEType]['previous'];
            this.percentage += this.step > 2 ? PERCENTAGE['additional'] : 0;
            this.percentage += Math.floor(this.activePage / this.total * PERCENTAGE[this.step]);
            return this.percentage;
        }
        return 0;
    }
}